<template>
  <ul class="info_detail_list">
    <li v-if="time" class="schedule_detail_item item-time">
      <div class="detail_icon">
        <img :src="$designResource.iconClock" alt>
      </div>
      <div class="detail_text">{{time}}</div>
    </li>
    <li v-if="subject" class="schedule_detail_item">
      <div class="detail_icon">
        <img :src="$designResource.iconMember" alt>
      </div>
      <div class="detail_text">{{subject}}</div>
    </li>
    <li v-if="userName || userAddress" class="schedule_detail_item">
      <div class="detail_icon">
        <img :src="$designResource.iconPerson" alt>
      </div>
      <div class="detail_text">
        <div>{{userName}}</div>
        <div>{{userAddress}}</div>
      </div>
    </li>
    <li v-if="roomName" class="schedule_detail_item item-place">
      <div class="detail_icon">
        <img :src="$designResource.iconDoor" alt>
      </div>
      <div class="detail_text">{{roomName}}</div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      required: false
    },
    subject: {
      type: String,
      required: false
    },
    userName: {
      type: String,
      required: false
    },
    userAddress: {
      type: String,
      required: false
    },
    roomName: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss">
.info_detail_list {
  width: 100%;
}
.schedule_detail {
  width: 100%;
}
.schedule_detail_item {
  width: 100%;
  display: flex;
  padding: 4px 0;
  box-sizing: border-box;
}
.item-time {
  color: $txtColor;
  font-weight: bold;
}
.item-place {
  padding-top: 10px;
  font-size: 12px;
}
.detail_icon {
  width: 25px;
}
.detail_icon > img {
  width: 20px;
}
.detail_text {
  width: calc(100% - 25px);
  line-height: 1.4;
}
</style>